<div
  class="header"
  matRipple
  [class.large-header]="variation === 'large'"
  [class.small-header]="variation === 'small'"
  (click)="changeVisibility()"
>
  <h4 i18n>{{ headerName }}</h4>
  <mat-icon>{{ showContent ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
</div>

@if (showContent) {
  <div [class.large-content]="variation === 'large'" [class.dt-help-padding]="variation === 'large'">
    <ng-content></ng-content>
  </div>
}
